<div class="modal-header">
  <h4 class="modal-title fw-normal">Send Deposit Request</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <p class="text-secondary">
    Texts the customer an Authvia payment link for the amount below. A sent request is not a
    collected payment — the deposit is confirmed separately once the customer pays.
  </p>

  <form [formGroup]="form" (ngSubmit)="confirm()">
    <div class="mb-3">
      <label for="amount" class="form-label">Amount <span class="text-danger">*</span></label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          id="amount"
          type="number"
          min="0.01"
          step="0.01"
          class="form-control"
          formControlName="amount"
          [class.is-invalid]="form.controls.amount.touched && form.controls.amount.invalid"
        />
      </div>
    </div>

    <div class="form-check mb-3">
      <input
        id="textDifferentPerson"
        type="checkbox"
        class="form-check-input"
        formControlName="textDifferentPerson"
      />
      <label for="textDifferentPerson" class="form-check-label">Text a different person</label>
    </div>

    @if (form.controls.textDifferentPerson.value) {
    <div class="row g-2 mb-2">
      <div class="col">
        <label for="firstName" class="form-label"
          >First name <span class="text-danger">*</span></label
        >
        <input
          id="firstName"
          type="text"
          class="form-control"
          formControlName="firstName"
          [class.is-invalid]="form.controls.firstName.touched && form.controls.firstName.invalid"
        />
      </div>
      <div class="col">
        <label for="lastName" class="form-label"
          >Last name <span class="text-danger">*</span></label
        >
        <input
          id="lastName"
          type="text"
          class="form-control"
          formControlName="lastName"
          [class.is-invalid]="form.controls.lastName.touched && form.controls.lastName.invalid"
        />
      </div>
    </div>
    <div class="mb-2">
      <label for="phoneNumber" class="form-label"
        >Phone number <span class="text-danger">*</span></label
      >
      <input
        id="phoneNumber"
        type="tel"
        class="form-control"
        formControlName="phoneNumber"
        [class.is-invalid]="form.controls.phoneNumber.touched && form.controls.phoneNumber.invalid"
      />
    </div>
    <div class="mb-2">
      <label for="email" class="form-label">Email</label>
      <input
        id="email"
        type="email"
        class="form-control"
        formControlName="email"
        [class.is-invalid]="form.controls.email.touched && form.controls.email.invalid"
      />
    </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">
    Cancel
  </button>
  <groundworks-loading-button
    [label]="'Send Deposit Request'"
    [loading]="isSubmitting"
    [disabled]="form.invalid"
    (click)="confirm()"
  />
</div>
